module.exports = __webpack_public_path__ + "media/images/placholder_logo-0732adcf09e407edd8c0f9670087f0b7.png";